import React from 'react';
import { Spin } from 'antd';

const Spinner = () => (
    <div className='spinner text-center'>
        <Spin />
    </div>
);

export default Spinner;
